<template>
  <div class="IPRelayApp">
    <IprelayHeader />
    <main class="main--flexed content">
      <div v-if="status === 'loading'">{{ sharedState.strings.loading }}</div>
      <div v-else-if="status === 'error'">{{ sharedState.strings.error_loading }}</div>
      <div v-else-if="status === 'notfound'">{{ sharedState.strings.page_not_found }}</div>
      <div v-else ref="content" v-html="currentPageContent"></div>
    </main>
    <IprelayFooter />
  </div>
</template>
<script>
/* eslint vue/no-v-html: 0 */
import { mapGetters } from 'vuex'
import IprelayFooter from './IprelayFooter'
import IprelayHeader from './IprelayHeader'

export default {
  name: 'Page',
  components: { IprelayFooter, IprelayHeader },
  data: function() {
    return {
      currentPage: '',
      status: 'idle',
      currentPageContent: '',
    }
  },
  computed: {
    ...mapGetters(['sharedState']),
  },
  created: function() {
    this.fetchPage(window.location.pathname)
  },
  methods: {
    fetchPage: function(pathname) {
      this.status = 'loading'
      const currentPage = this.currentPage

      const xhr = new XMLHttpRequest()
      xhr.open('GET', '/api/' + pathname)
      xhr.onload = () => {
        if (currentPage === this.currentPage) {
          if (xhr.status >= 200 && xhr.status < 300) {
            this.status = 'done'
            this.currentPageContent = xhr.responseText
          } else if (xhr.status === 404) {
            this.status = 'notfound'
          } else {
            this.status = 'error'
          }
        }
      }
      xhr.send()
    },
  },
}
</script>
<style scoped>
.content {
  max-width: 800px;
  margin: auto;
  padding: 2rem;
}
</style>
